import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ChangeManagerService } from '../change-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeManagerGuard {
  private changeManager = inject(ChangeManagerService);

  canDeactivate(): Observable<boolean> {
    return this.changeManager.dirty ? this.changeManager.promptDecision() : of(true);
  }
}
